import { render } from "./IconOdd.vue?vue&type=template&id=30f0bfa6&ts=true"
import script from "./IconOdd.vue?vue&type=script&lang=ts"
export * from "./IconOdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__